import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCareer = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.0004 16L16.0004 29M10.0003 25H10.0503M23.0003 28H23.0503M19.0003 6H19.0503M31.0004 10.4921C22.4461 8.05096 15.2225 15.081 16.0678 23C28.3373 22.4998 25.7195 14.1134 31.0004 10.4921ZM1.00037 4.16351C10.6897 2.69058 17.6493 11.4266 15.6595 20C2.29997 17.7201 6.29233 8.88359 1.00037 4.16351Z",
		stroke: "#DFCBF5",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCareer;
